var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgImgGuidelineSupport = function SvgImgGuidelineSupport(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 44,
    height: 44,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#8CB2F4",
    fillRule: "evenodd",
    d: "M22 4.58C12.379 4.58 4.58 12.378 4.58 22S12.378 39.42 22 39.42q.436 0 .868-.02l.164 3.336a21 21 0 0 1-1.032.026C10.533 42.762 1.238 33.466 1.238 22S10.533 1.238 22 1.238c11.466 0 20.76 9.296 20.76 20.762q0 .26-.006.518l-3.34-.082q.005-.217.005-.436c0-9.621-7.8-17.42-17.42-17.42",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#8CB2F4",
    fillRule: "evenodd",
    d: "m42.33 26.033-.45 1.61q-.231.832-.53 1.635l-3.132-1.164q.25-.672.445-1.37l.45-1.61zm-2.44 6.354a21 21 0 0 1-1.951 2.824l-2.583-2.12a17.5 17.5 0 0 0 1.638-2.37zm-4.34 5.289a21 21 0 0 1-2.76 2.04l-1.757-2.84q1.232-.764 2.317-1.714zm-5.82 3.599a21 21 0 0 1-1.617.583l-1.594.501-1.001-3.187 1.593-.5a17 17 0 0 0 1.356-.49z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#4080ED",
    d: "M22 34.886c7.117 0 12.886-5.77 12.886-12.886 0-7.117-5.77-12.887-12.886-12.887-7.117 0-12.887 5.77-12.887 12.887S14.883 34.886 22 34.886"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillRule: "evenodd",
    d: "M27.217 18.059a1.67 1.67 0 0 1 .155 2.357l-5.474 6.245a1.67 1.67 0 0 1-2.51.003l-3.123-3.546a1.67 1.67 0 0 1 2.508-2.208l1.866 2.119 4.22-4.815a1.67 1.67 0 0 1 2.358-.155",
    clipRule: "evenodd"
  })));
};
export default SvgImgGuidelineSupport;